import axios from 'axios';
import Swal from 'sweetalert2';
import { getCountryNameByCode } from '@SHARED/js/helpers/misc';
import FormHelperMixin from '@SHARED/js/Vue/mixins/FormHelperMixin';
import template from './RegisterCustomerUserComponent.html';

export default {
  template,

  mixins: [FormHelperMixin],

  data() {
    return {
      formData: {
        firstname: '',
        lastname: '',
        email: '',
        mobile_prefix: '+47',
        mobile: '',
        password: '',
        password_confirm: '',
        company_org_number: '',
        company_name: '',
        company_address1: '',
        company_address2: '',
        company_postal_code: '',
        company_city: '',
        company_country: 578, // Defaults to Norge – see config/vismaCountries.php for IDs
        company_mobile_prefix: '+47',
        company_mobile: '',
        isCompanyAccount: false,
      },
      isLoading: false,
    };
  },

  methods: {
    checkPasswords() {
      if (this.formData.password !== this.formData.password_confirm) {
        this.addAttrError('password_confirm', 'Passordene er ikke like');
      } else {
        this.removeAttrError('password_confirm');
      }
    },

    submitForm() {
      // Prevent double click
      if (!this.isLoading) {
        this.storeCustomerUser();
      }
    },

    getCountryNameByCode,

    // API

    storeCustomerUser() {
      this.isLoading = true;
      this.clearErrors();

      // TODO Do not send company data if isCompanyAccount is set to false, or ignore them in Request
      axios.post('/api/v1/customer/store', this.formData)
        .then((response) => {
          Swal.fire({
            title: 'Konto opprettet',
            type: 'success',
            timer: 2000,
            showConfirmButton: false,
          })
            .then(() => {
              this.$emit('register-customer-user-success', response.data);
            });
        })
        .catch((error) => {
          if (typeof error.response.data.errors !== 'undefined') {
            this.errors = error.response.data.errors;
            this.addAttrError('message', 'Kunne ikke opprette kundeforholdet. Sjekk at feltene er riktig.');

            if (this.getAttrError('company_org_number') &&
                this.getAttrError('company_org_number').includes('exists')
            ) {
              Swal.fire(
                'Organisasjonsnummeret eksisterer fra før',
                'Vennligst kontakt Kraftex for tilgang ved å ringe (<a href="tel:69252530">69&nbsp;25&nbsp;25&nbsp;30</a>).<br>' +
                'For henvendelser utenom våre åpningstider, bruk vårt <a href="/kontakt-oss" target="_blank">kontaktskjema</a>, så tar vi kontakt med deg.',
                'warning',
              );
            }
          } else {
            Swal.fire(
              'Noe gikk galt',
              'Vennligst prøv igjen. Om problemet vedvarer, ring Kraftex (<a href="tel:69252530">69 25 25 30</a>).<br>' +
              'Feil utenom våre åpningstider melder du <a href="/kontakt-oss" target="_blank">her</a>, så tar vi kontakt med deg.',
              'error',
            );

            window.bugsnagClient && window.bugsnagClient.notify(error);
            throw new Error(error);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
